import { posDateTimeText } from '../utils/posUtil';
import '../css/Pos.css';

/**
 * The "this sale was deleted" panel shown above a deleted sale's receipt:
 * the reason, and who deleted it and when.
 *
 * Its own component so any screen that reads a deleted order back (Sales
 * today) shows the same wording.
 *
 * @param {object} props
 * @param {{reason: string, deletedBy?: string, deletedAt?: string}} props.deletion
 * @returns {JSX.Element|null}
 */
function PosSaleDeletionNote({ deletion }) {
  if (!deletion) return null;
  return (
    <div className="pos-sale-deleted" role="note">
      <strong className="pos-sale-deleted-title">Cancelled / Deleted</strong>
      <p className="pos-sale-deleted-reason"><span>Reason:</span> {deletion.reason}</p>
      <p className="pos-sale-deleted-meta">
        {deletion.deletedBy || 'Unknown'}
        {deletion.deletedAt ? ` · ${posDateTimeText(deletion.deletedAt)}` : ''}
      </p>
    </div>
  );
}

export default PosSaleDeletionNote;
